import { render, staticRenderFns } from "./_action.vue?vue&type=template&id=86d0d8d8&scoped=true&"
import script from "./_action.vue?vue&type=script&lang=js&"
export * from "./_action.vue?vue&type=script&lang=js&"
import style0 from "./_action.vue?vue&type=style&index=0&id=86d0d8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d0d8d8",
  null
  
)

export default component.exports